import React from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { makeStyles } from '@material-ui/core/styles';
import './Editor.scss';

const italic = Quill.import('formats/italic');
italic.tagName = 'i'; // Quill uses <em> by default
Quill.register(italic, true);

const useStyles = makeStyles({});

interface ToolBarOptions {
  toolbar: string[][] | boolean;
  handlers?: any;
}

interface EditorProps {
  disableToolbar?: boolean;
  handleChange?: (...args: any) => any;
  placeholder?: string;
  value: string;
}

const Editor: React.FC<EditorProps> = (props: EditorProps) => {
  const classes = useStyles();
  let toolbarOptions: ToolBarOptions = {
    toolbar: [['bold', 'italic']]
  };

  if (props.disableToolbar) {
    toolbarOptions = {
      toolbar: false
    };
  }

  const { handleChange, placeholder, value } = props;

  const handleQuillChange = (evt: string) => {
    const filteredStyleText = evt.replace(/ style=("|\')(.*?)("|\')/g, '');
    let filteredSpanText = filteredStyleText.replace(/<span/g, '<p');
    filteredSpanText = filteredSpanText.replace(/<\/span/g, '</p');
    if (handleChange) {
      handleChange(filteredSpanText);
    }
  };
  return (
    <ReactQuill
      className={'react-quill-editor'}
      theme={'snow'}
      value={value}
      placeholder={placeholder || ''}
      onChange={handleQuillChange}
      modules={toolbarOptions}
    />
  );
};
export default Editor;
